import AssignDevicesModal from './AssignDevicesModal';

export default AssignDevicesModal;
